// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"31e0d11f","387":"dfa57e99","544":"2ee4d36c","610":"45e6a02e","612":"b94339b2","615":"72a829f6","736":"ebba321f"}[chunkId] + ".chunk.js";
};